import './axios-config'

import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'

import { extractPaths } from './extract-paths'
import { iCall, iCommunicationModuleConfig, iPathObj } from './types'
import { composeUrl, getProtocol } from './utils'

type iCommunicationModule = (
  params: iCommunicationModuleConfig,
) => Promise<{
  call: iCall
  api: iPathObj
}>
const init: iCommunicationModule = async ({
  paths,
  host = location.hostname,
  basepath = '',
  protocol = getProtocol(),
  timeout = 0,
}) => {
  const call = async function <Response = any, Request = any>(
    config: AxiosRequestConfig<any>,
  ): Promise<AxiosResponse<Response, Request>> {
    const reqConfig = {
      baseURL: composeUrl({ protocol, host, basepath }),
      timeout,
      ...config,
    }
    return await axios.request(reqConfig)
  }

  call.api = extractPaths({
    paths,
    generalConfig: {
      host,
      basepath,
      protocol,
      timeout,
    },
  })

  return {
    call,
    api: call.api,
  }
}

export default init
